import { RouteInterface } from '@/src/common/enums/routes'

export const NotificationsRoutes = {
  GoToSystemSettings: {
    route: `/main/notifications/go-to-notifications-settings`,
    name: 'Notifications - Go To Notifications Setting',
    availableForDeepLinking: false,
  },
  Request: {
    route: '/main/notifications/request-notifications-permissions',
    name: 'Notifications - Request Notifications Permissions',
    availableForDeepLinking: false,
  },
  Settings: {
    route: '/main/notification-settings',
    name: 'Notifications - User Notification Settings',
    availableForDeepLinking: true,
  },
  Center: {
    route: '/main/notification-center',
    name: 'Notifications - User Notification Center',
    availableForDeepLinking: true,
  },
} as const satisfies Record<string, RouteInterface>
